var exports = {
  "k": "x31de4314--c20d0e--hotel-button",
  "K": "x31de4314--c20d0e--badges-row",
};

module.exports = exports;
